module.exports = __webpack_public_path__ + "static/media/icon_car_right_side.2cfea7ea.svg";